export const pdfViewStyles = {
  display: 'flex',
  width: '100%',
  height: '80vh',
};
